import { Button, Dropdown, DropdownItem, DropdownMenu, DropdownTrigger } from "@heroui/react"
import { ChevronDownIcon, ListBulletIcon } from "@heroicons/react/20/solid"
import PropTypes from "prop-types"

const ColumnSelector = ({ columns, selectedColumns, toggleColumn }) => {
  const optionalColumns = Object.keys(columns).filter(key => columns[key].deselectable)

  return (
    <Dropdown>
      <DropdownTrigger className="flex-shrink-0 hidden sm:flex">
        <Button
          startContent={<ListBulletIcon className="w-auto h-5" />}
          endContent={<ChevronDownIcon className="w-auto h-5 outline-none" />}
          variant="flat"
        />
      </DropdownTrigger>

      <DropdownMenu
        aria-label="Table Columns"
        disallowEmptySelection
        closeOnSelect={false}
        selectedKeys={selectedColumns}
        selectionMode="multiple"
        onSelectionChange={toggleColumn}
      >
        {optionalColumns.map(key => (
          <DropdownItem key={key} className="capitalize">
            {columns[key].name}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  )
}

ColumnSelector.propTypes = {
  columns: PropTypes.object.isRequired,
  selectedColumns: PropTypes.array.isRequired,
  toggleColumn: PropTypes.func.isRequired,
}

export default ColumnSelector
